/**
 * @fileoverview GET handler for the "/api/calculated_filters/:id/:app_group_id/engagements" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { apiCalculatedFiltersIdAppGroupIdEngagements } from "./constants";
import type { EngagementsResponse } from "./types";
import { isGetApiCalculatedFiltersIdAppGroupIdEngagementsResult } from "./validators";

export const getApiCalculatedFiltersIdAppGroupIdEngagements = reactQueryFetcherAdapter(
  apiCalculatedFiltersIdAppGroupIdEngagements,
  (signal: AbortSignal, id: string, appGroupId: string, includeInactive: boolean): Promise<EngagementsResponse> => {
    return fetch(
      `/api/calculated_filters/${id}/${appGroupId}/engagements`,
      "GET",
      { include_inactive: includeInactive },
      { signal }
    );
  },
  isGetApiCalculatedFiltersIdAppGroupIdEngagementsResult
);
